<template>
    <div class="upload-meeting-bill-file"
         v-loading.fullscreen.lock="uploading"
    >
        <div class="upload-file-box">
            <el-upload
                    ref="upload"
                    action=""
                    :auto-upload="false"
                    :on-change="onChangeHandler"
                    :http-request="myUploadFunc"
                    :limit="10"
                    :on-exceed="onExceedHandler"
                    :before-upload="beforeUploadHandler"
                    :on-remove="removeFile"
                    :file-list="willUploadList"
                    accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .xls, .xlsx"
                    multiple
            >

                <el-button slot="trigger" size="small" type="primary" icon="el-icon-plus">选取文件</el-button>
                <el-button style="margin-left: 10px;height: 34px" size="small" type="success" @click.stop="submitUpload" icon="el-icon-upload">上传到服务器</el-button>
                <div slot="tip" class="el-upload__tip">单次最多选择10个文件</div>

            </el-upload>

        </div>

        <div class="table-box">
            <el-table :data="tableList" border style="width: 100%;">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column
                        v-for="(prop, index) in tableProps"
                        :key="index"
                        :prop="prop.prop"
                        :label="prop.label"
                        :min-width="prop.width"
                ></el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="text"
                                @click="removeUploadedFile(scope)"
                                icon="el-icon-delete"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { uploadConferenceFile } from '@/services/declarationServices';
    import Constants from '@/utils/consts';
    export default {
        name: "uploadFile",
        props: {
            tableList: {
                // 表格里的上传文件列表
                type: Array,
                default: () => {
                    return [];
                },
            },
        },
        data() {
            return {
                tableProps: [
                    { prop: "name", label: "文件名称", width: "280px" },
                    { prop: "createUserName", label: "上传者", width: "140px" },
                    { prop: "createTime", label: "上传时间", width: "140px" },
                ],
                willUploadList: [], //将要上传的文件列表.这里添加文件时选择同名列表，回调的参数fileList仍然不会删除同名的，那就自己保存个上传列表，并在on-change时自己手动更新，以确保没有重复文件
                fileFormData: null, // 用来上传文件的二进制流
                uploading: false,
            };
        },
        methods: {
            removeUploadedFile(scope) {

                // 在表格里删除已经上传好的文件.删除已经上传好的文件，不需要真的调用删除接口，只要最后保存时从文件列表中删掉就行了
                this.$confirm("确定要删除此附件吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        let { attachmentItem } = scope.row;
                        let left = [];
                        this.tableList.forEach(item => {
                            if (item.attachmentItem != attachmentItem) {
                                left.unshift(item);
                            }
                        });
                        this.$emit('submit', left);
                    })
                    .catch(error => {
                        if (error instanceof Error) {
                            this.$message.error(error.message);
                        }
                    });
            },
            onChangeHandler(file, fileList) {
                // 按理这里是状态变化的钩子函数，好几种状态变化都会回调这个方法，
                // 但是这个项目里重写了执行逻辑，所以在添加时候会回调这里，删除，上传成功和失败并不会回调这里
                // uid name raw:File
                // element里并没有在选择文件时，对是否会重复选择进行处理.所以要在这里判断下是否有重复的，如果有，删除掉
                // this.willUploadList = [...__list]; 这行很重要，要重新赋值，从而出发file-list的刷新，然后更改element内部的uploadFiles数组
                let __list = this.willUploadList;
                let index = this.willUploadList.findIndex(
                    (item) => item.name == file.name
                );
                if (index != -1) {
                    // 待上传列表不能有同名文件
                    this.willUploadList = [...__list];
                    this.$message.warning("请不要重复选择文件");
                    return;
                }
                index = this.tableList.findIndex((item) => item.name == file.name);
                if (index != -1) {
                    // 待上传的文件也不能跟已上传的文件重名
                    this.willUploadList = [...__list];
                    this.$message.warning("请不要上传重复文件");
                    return;
                }
                this.willUploadList.unshift(file);
            },
            myUploadFunc(file) {
                // 这个项目里的上传改写了原本的逻辑
                // 点击提交后，先调用 this.fileFormData = new FormData()，生成一个新的二进制对象，为了添加要上传的文件
                // 然后调用submit方法，upload组件会在发现自定已http-request，并执行它。这样就将要上传的文件打包进了FormData
                // 然后调用接口上传FormData对象，返回对应的链接
                this.fileFormData.append("file", file.file);
            },
            onExceedHandler() {
                this.$alert("单次最多选择10个文件", "提示", {
                    confirmButtonText: "确定",
                    type: "warning"
                });
            },
            beforeUploadHandler() {
                // 点击submit，要提交文件时执行。目前不需要做什么处理
                console.log('before upload', this.willUploadList);
                return true;
            },
            removeFile(file, fileList) {
                // 要删除待上传文件
                this.willUploadList = [...fileList];
            },
            submitUpload() {
                // 手动点击上传服务器
                if (this.willUploadList.length == 0) {
                    this.$alert("请选择要上传的附件", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                    return;
                }
                if(this.willUploadList.length > 10) {
                    this.$alert("单次最多选择10个文件", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                    return;
                }

                // 判断名字是否超过100个字
                let index = this.willUploadList.findIndex(item => item.name.length> 100)
                if (index != -1 ){
                    this.$alert("附件名字长度超过100字，请重新确认！", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                    return;
                }

                this.uploading = true;

                this.fileFormData = new FormData();
                this.$refs.upload.submit();
                uploadConferenceFile(this.fileFormData).then(res => {
                    if (res.code == Constants.Code_OK) {
                        let data = res.data || [];
                        let forTable = [];
                        let date = new Date();
                        let currentUser = sessionStorage.getItem("name");
                        let currentUserId = sessionStorage.getItem("currentUserId");
                        let timeStr = date.getFullYear() +"-" +(date.getMonth() + 1) +"-" + date.getDate() +" " +date.getHours() +":" +date.getMinutes() +":" +date.getSeconds();
                        // fileName path
                        data.forEach(file => {
                            let item = {
                                attachmentItem: file.path,
                                name: file.fileName,
                                createUserName: currentUser,
                                createTime:timeStr,
                                createUserId: currentUserId,
                                outputBillApproveId: 0,
                            };
                            forTable.unshift(item);
                        });
                        // let allFileList = this.tableList.concat(forTable);
                        let allFileList = forTable.concat(this.tableList);
                        this.willUploadList = [];
                        this.$refs.upload.clearFiles();
                        this.fileFormData = null;
                        this.$message.success(Constants.Upload_OK_Msg);
                        this.$emit('submit', allFileList);
                    } else if (res.code >= Constants.Code_Err) {
                        this.$alert(res.msg, "提示", {
                            confirmButtonText: "确定",
                        });
                    } else {
                        this.$message.error(res.Msg);
                    }
                }).catch(error => {
                    this.$message.error(Constants.Err_Msg);
                }).finally(() => {
                    this.uploading = false;
                })
            }
        },
    };
</script>

<style lang="scss" scoped>

    .upload-file-box {
        text-align: left;
        margin-bottom: 20px;

        /deep/.el-icon-close {
            background: #F56C6C;
        }

        /deep/.el-upload-list__item:focus {
            outline: none;
        }
    }

</style>
